module.exports = __webpack_public_path__ + "img/ToxicTundra.9108ddba.png";